/** Supply Ops M8 UI is OFF unless REACT_APP_SUPPLY_OPS_M8 is explicitly 1, true, or on. */
export function isSupplyOpsM8Enabled(): boolean {
  const value = String(process.env.REACT_APP_SUPPLY_OPS_M8 || '').trim().toLowerCase();
  return value === '1' || value === 'true' || value === 'on';
}
